import $ from "jquery";
const onClickInARow = () => {
  const init = () => {
    handleClick();
  };

  const handleClick = () => {
    $(document).on("click", ".js-redirect-data-url-on-click", function () {
      const url = $(this).data("url");

      window.location.href = url;
    });
  };

  init();
};

try {
  onClickInARow();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
